{/*
  * ORTBChangelogPage.tsx
  * https://dash.applovin.com/documentation/mediation/auctions/dsps/ortb-spec/changelog
  * Documentation > MAX Demand Partners > DSPs > ORTB Specification > Changelog
  */}
import React, { FunctionComponent } from 'react';
import { DataTable, DocsPageModule } from 'UI-Dash-Commons-UI';
import styled from 'styled-components';

type ORTBChangelogPageProps = {
    linkTargetTopPosition?: number;
}

const ORTBChangelogPage: FunctionComponent<ORTBChangelogPageProps> = ( { linkTargetTopPosition } ) =>
{
    return (
        <>
            <DocsPageModule.DocsPageHeader linkTargetTopPosition={linkTargetTopPosition} text={'Changelog'}
                                           type={DocsPageModule.DocsPageHeaderType.HEADING_1}/>

            <DataTable
                data={[
                    {
                        date: 'Jul. 2023',
                        notes: 'Compressed/gzip oRTB required. Adhere to oRTB 2.5 section 2.4: Data Encoding.'
                    },
                    {
                        date: 'May 2023',
                        notes: 'Tracking URLs embedded in the VAST XML for video ads do not fire consistently for apps using Android SDK version 11.8.2 (released March 13, 2023) or 11.9.0 (released April 10, 2023). Issue is resolved as of SDK version 11.10.0 (released May, 21 2023).'
                    },
                    {
                        date: 'Apr. 2023',
                        notes: 'Smart Throttling enabled for all DSP buyers.'
                    },
                    {
                        date: 'Apr. 5, 2023',
                        notes: 'Include only those SKAdNetwork ID(s) in the \`imp[].ext.skadn\` bid request object that are integrated into the app and that belong exclusively to the DSP that the request is being sent to.'
                    },
                    {
                        date: 'Feb. 21, 2023',
                        notes: 'The \`imp.tagid\` bid request field is now unique to the ad unit. Prior to this, \`imp.tagid\` was not passed consistently, and a single value was used at the app/package level.'
                    },
                    {
                        date: 'Jan. 2023',
                        notes: 'Add support for CTV.'
                    },
                    {
                        date: 'Sep. 30, 2022',
                        notes: 'Add \`X-Device-IP\` and \`X-Device-User-Agent\` headers to server-to-server impression callbacks. \`X-Device-IP\` : Actual user device IP; \`X-Device-User-Agent\` : Actual user device UA.'
                    },
                    {
                        date: 'May 11, 2022',
                        notes: 'VAST Wrapper tags no longer supported for Android Rewarded.'
                    },
                    {
                        date: 'Feb. 24, 2022',
                        notes: 'Add support for Native format as of AppLovin SDK iOS 11.1.2 / Android 11.1.3.'
                    },
                    {
                        date: 'Dec. 31, 2021',
                        notes: 'Add support for passing IDFV in the \`device.ext.ifv\` field. Only passed when IDFA is not available. Currently passed for iOS only.'
                    },
                ]}
                columns={[
                    {
                        id: 'date',
                        Header: 'Release Date',
                        sortable: false,
                        Cell: props => <DocsPageModule.DocsPageContentText text={props.original.date}/>
                    },
                    {
                        id: 'notes',
                        Header: 'Notes',
                        sortable: false,
                        Cell: props => <ChangelogTableCell text={props.original.notes}/>
                    },
                ]}
                totalRowCount={10}
            />

        </>
    )
}

const ChangelogTableCell = styled( DocsPageModule.DocsPageContent )`
  white-space: normal;
`;

export default ORTBChangelogPage;
